export default __webpack_public_path__ + "static/media/Wallet_light.70c7c700.svg";